import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api } from "@/lib/api";
import { ago } from "@/lib/perms";

export const NotificationBell = () => {
  const [d, setD] = useState({ unread: 0, items: [] });
  const nav = useNavigate();
  const load = useCallback(() => api.get("/notifications").then((r) => setD(r.data)).catch(() => {}), []);
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, [load]);
  const open = (o) => { if (o && d.unread) api.post("/notifications/read").then(() => setD((x) => ({ ...x, unread: 0 }))); };
  return (
    <Popover onOpenChange={open}>
      <PopoverTrigger asChild>
        <button className="relative p-2 rounded-full text-slate-400 hover:text-amber-300 hover:bg-veil/5 transition-colors" data-testid="notification-bell">
          <Bell className="w-4 h-4" />
          {d.unread > 0 && <span className="absolute -top-0.5 -right-0.5 min-w-4 h-4 px-1 rounded-full bg-amber-500 text-onaccent text-[10px] font-bold leading-4 text-center" data-testid="notification-count">{d.unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0 bg-panel border-line" data-testid="notification-list">
        <p className="px-4 py-3 font-display text-lg text-amber-100 border-b border-line">Notifications</p>
        <div className="max-h-96 overflow-y-auto">
          {d.items.length === 0 && <p className="px-4 py-6 text-sm text-slate-500">You're all caught up.</p>}
          {d.items.map((n) => (
            <button key={n.id} onClick={() => nav(n.link)} className={`block w-full text-left px-4 py-3 border-b border-line/60 hover:bg-veil/5 ${n.read ? "" : "bg-amber-500/5"}`} data-testid={`notification-${n.id}`}>
              <p className="text-sm text-slate-200">{n.text}</p>
              <p className="text-[11px] text-slate-500 mt-0.5">{n.world_name} · {ago(n.created_at)}</p>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
